import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Popover from '@radix-ui/react-popover';
import { Bell } from 'lucide-react';
import IconButton from './IconButton';
import { useNotifications } from './NotificationsContext';
import NotificationsPanel from './NotificationsPanel';
import { useTheme } from './theme/ThemeProvider';

/**
 * Bell with an unread dot. From tablet up it opens the notifications panel; on phones it opens
 * the full notifications page when the dashboard provides one (Figma N1).
 */
const NotificationsButton: React.FC = () => {
  const { portalContainer } = useTheme();
  const navigate = useNavigate();
  const { items, pagePath } = useNotifications();
  const [open, setOpen] = useState(false);
  const unread = items.some((n) => !n.read);
  const label = unread ? 'Notifications, unread' : 'Notifications';

  return (
    <>
      {pagePath && <IconButton icon={Bell} label={label} badge={unread} className="md:tw-hidden" onClick={() => navigate(pagePath)} />}
      <Popover.Root open={open} onOpenChange={setOpen}>
        <Popover.Trigger asChild>
          <IconButton icon={Bell} label={label} badge={unread} className={pagePath ? 'tw-hidden md:tw-flex' : undefined} />
        </Popover.Trigger>
        <Popover.Portal container={portalContainer}>
          <Popover.Content
            align="end"
            sideOffset={8}
            collisionPadding={16}
            className="tw-z-50 tw-w-[400px] tw-max-w-[calc(100vw-32px)] tw-rounded-2xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-p-4 tw-shadow-ds-modal focus:tw-outline-none"
          >
            <NotificationsPanel variant="popover" onNavigate={() => setOpen(false)} />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </>
  );
};

export default NotificationsButton;
